"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModal = exports.ModalType = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Modal_1 = __importDefault(require("@material-ui/core/Modal"));
const icons_1 = require("../../icons");
var ModalType;
(function (ModalType) {
    ModalType["ERROR"] = "error";
    ModalType["INFORMATION"] = "information";
    ModalType["WARNING"] = "warning";
})(ModalType = exports.ModalType || (exports.ModalType = {}));
const getIcon = (type) => {
    switch (type) {
        case ModalType.WARNING:
            return react_1.default.createElement(icons_1.WarningIcon, null);
        case ModalType.ERROR:
            return react_1.default.createElement(icons_1.ErrorIcon, null);
        case ModalType.INFORMATION:
            return react_1.default.createElement(icons_1.InformationIcon, null);
    }
};
exports.BaseModal = (props) => {
    const { children, disableBackdropClick = true, onEscape, open = true, title, type = ModalType.INFORMATION, } = props;
    const modalProps = {
        disableBackdropClick,
        onClose: onEscape,
        open,
    };
    return (react_1.default.createElement(Modal_1.default, Object.assign({}, modalProps),
        react_1.default.createElement(core_1.Card, { className: "modal" },
            react_1.default.createElement("div", { className: "modal-header" },
                react_1.default.createElement("div", { className: "modal-header-icon" }, getIcon(type)),
                react_1.default.createElement("div", null, title)),
            children)));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFzZU1vZGFsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2ZlZWRiYWNrL21vZGFscy9CYXNlTW9kYWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUdzQztBQUN0Qyw0Q0FBa0Q7QUFDbEQsb0VBR3dEO0FBQ3hELHVDQUk0QztBQUU1QyxJQUFZLFNBSVg7QUFKRCxXQUFZLFNBQVM7SUFDakIsNEJBQXFCLENBQUE7SUFDckIsd0NBQTJCLENBQUE7SUFDM0IsZ0NBQXVCLENBQUE7QUFDM0IsQ0FBQyxFQUpXLFNBQVMsR0FBVCxpQkFBUyxLQUFULGlCQUFTLFFBSXBCO0FBZ0JELE1BQU0sT0FBTyxHQUFHLENBQUMsSUFBZSxFQUFFLEVBQUU7SUFDaEMsUUFBUSxJQUFJLEVBQUU7UUFDVixLQUFLLFNBQVMsQ0FBQyxPQUFPO1lBQ2xCLE9BQU8sOEJBQUMsbUJBQVcsT0FBRSxDQUFDO1FBRTFCLEtBQUssU0FBUyxDQUFDLEtBQUs7WUFDaEIsT0FBTyw4QkFBQyxpQkFBUyxPQUFFLENBQUM7UUFFeEIsS0FBSyxTQUFTLENBQUMsV0FBVztZQUN0QixPQUFPLDhCQUFDLHVCQUFlLE9BQUUsQ0FBQztLQUNqQztBQUNMLENBQUMsQ0FBQztBQUVXLFFBQUEsU0FBUyxHQUFzQyxDQUFDLEtBQXFCLEVBQUUsRUFBRTtJQUVsRixNQUFNLEVBQ0YsUUFBUSxFQUNSLG9CQUFvQixHQUFLLElBQUksRUFDN0IsUUFBUSxFQUNSLElBQUksR0FBcUIsSUFBSSxFQUM3QixLQUFLLEVBQ0wsSUFBSSxHQUFxQixTQUFTLENBQUMsV0FBVyxHQUNqRCxHQUFHLEtBQUssQ0FBQztJQUVWLE1BQU0sVUFBVSxHQUE4QjtRQUMxQyxvQkFBb0I7UUFDcEIsT0FBTyxFQUFFLFFBQVE7UUFDakIsSUFBSTtLQUNQLENBQUM7SUFFRixPQUFPLENBQ0gsOEJBQUMsZUFBSyxvQkFDRSxVQUFVO1FBRWQsOEJBQUMsV0FBSSxJQUFDLFNBQVMsRUFBQyxPQUFPO1lBQ25CLHVDQUFLLFNBQVMsRUFBQyxjQUFjO2dCQUN6Qix1Q0FBSyxTQUFTLEVBQUMsbUJBQW1CLElBQzVCLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FDYjtnQkFDTiwyQ0FDTSxLQUFLLENBQ0wsQ0FDSjtZQUNKLFFBQVEsQ0FDUCxDQUNILENBQ1gsQ0FBQztBQUNOLENBQUMsQ0FBQyJ9